import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";
import { Badge, Fab } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useWarehouseShoppingListBuffer } from "../../../../../../contexts/WarehouseShoppingListBuffer";
import WarehouseShoppingListPanel from "./WarehouseShoppingListPanel";

// Same visibility rule as WarehouseLabelQueueFab.jsx - hidden until the
// buffer has something in it. Positioning is owned by the parent
// (WarehouseQueueFabs.jsx), which stacks this alongside the label queue FAB
// rather than both floating at the same fixed coordinates.
export default function WarehouseShoppingListFab() {
  const { t } = useTranslation();
  const { count } = useWarehouseShoppingListBuffer();
  const [open, setOpen] = useState(false);

  if (count === 0) {
    return null;
  }

  return (
    <>
      <Fab
        color="secondary"
        onClick={() => setOpen(true)}
        title={t("ShoppingList")}
      >
        <Badge badgeContent={count} color="error">
          <ShoppingBagOutlined />
        </Badge>
      </Fab>
      <WarehouseShoppingListPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
